import { Divider } from 'antd'
import React, { useState } from 'react'
import { useRouter } from 'next/router'
import { Message } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { getDateFormatted } from 'src/core/helpers'
import { userAuthenticatedState } from 'src/features'
import MessageReplyForm from './MessageReplyForm/MessageReplyForm'
import MessageItemButton from './MessageItemButton/MessageItemButton'
import { FileDoneOutlined, MessageOutlined } from '@ant-design/icons'
import { CustomModal, CustomTitle, CustomText, CustomLink } from 'src/components'

interface MessageItemProps {
  isModalVisible: boolean
  handleCancel: Function
  message: Message
}

const MessageItemModal: React.FC<MessageItemProps> = (props) => {
  const { isModalVisible, handleCancel, message } = props
  const [showReplyForm, setShowReplyForm] = useState(false)
  const { t } = useTranslation()
  const router = useRouter()
  const user = useAppSelector(userAuthenticatedState)
  const canReply = !message.system && message.receiver === user?.id

  const goToProductsSold = () => {
    router.push('/my-sales')
  }

  const getFromText = () => {
    const sender = {
      ANONYMOUS: message.anonymous_sender_email,
      USER: `${message.sender_name} ${message.sender_lastname}`
    }[message.is_anonymous_user ? 'ANONYMOUS' : 'USER']

    return message.system ? 'ClimateTrade' : `${sender}`
  }

  const handleClose = () => {
    setShowReplyForm(false)
    handleCancel()
  }

  const handleFormCancel = ({ closeModal = false }) => {
    setShowReplyForm(false)
    if (closeModal) {
      handleCancel()
    }
  }

  return (
    <>
      <CustomModal
        title={<CustomText label={message.subject} />}
        footer={null}
        open={isModalVisible}
        onCancel={handleClose}
      >
        <CustomTitle label={t('Messages.FromText', { text: getFromText() })} type={null} />
        <CustomText label={message.content} />

        {message.is_anonymous_user && <Divider />}
        <CustomText label={getDateFormatted(message.date)} mark className='float-right' />
        {message.is_anonymous_user && <CustomText label={t('Messages.AnonymousEmail')} type='secondary' />}


        <Divider />

        {(canReply && !showReplyForm) && <>
          {message.is_anonymous_user ? (
            <CustomLink
              link={`mailto:${message.anonymous_sender_email}`}
              label={t('Messages.SendEmail')}
              showIcon={false}
            />
          ) : <MessageItemButton
            icon={<MessageOutlined />}
            handleClick={() => setShowReplyForm(true)}
            label={t('Messages.ReplyMessage')}
          />}
        </>}

        {message.type === 'cancel_certificate' && (
          <MessageItemButton
            icon={<FileDoneOutlined />}
            handleClick={() => goToProductsSold()}
            label={t('Messages.CertificateClick')}
          />
        )}

        {showReplyForm && (
          <MessageReplyForm
            handleCancel={handleFormCancel}
            message={message}
          />
        )}
      </CustomModal>
    </>
  )
}
export default MessageItemModal
